import { useTranslation } from 'react-i18next';

interface StepActionsProps {
  /** Rótulo do botão primário (avançar/enviar). */
  submitLabel: string;
  loading?: boolean;
  loadingLabel?: string;
  disabled?: boolean;
  /** Se definido, exibe o botão "Voltar". */
  onBack?: () => void;
  backLabel?: string;
}

/** Rodapé padrão dos passos: botão "Voltar" (opcional) + botão primário. */
export function StepActions({
  submitLabel,
  loading = false,
  loadingLabel,
  disabled = false,
  onBack,
  backLabel,
}: StepActionsProps) {
  const { t } = useTranslation();
  const resolvedLoadingLabel = loadingLabel ?? t('common.wait', 'Aguarde...');
  const resolvedBackLabel = backLabel ?? t('common.back', 'Voltar');
  return (
    <div className="flex items-center gap-3 mt-[24px]">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          className="py-[11px] px-[18px] rounded-[22px] border-0 cursor-pointer text-[13px] font-medium text-navy-800 bg-mist-100 hover:bg-mist-300/60 transition-colors disabled:opacity-50"
        >
          <i className="fa fa-arrow-left mr-2" aria-hidden="true"></i>
          {resolvedBackLabel}
        </button>
      )}
      <button
        type="submit"
        disabled={loading || disabled}
        className="flex-1 py-[11px] px-[18px] rounded-[22px] border-0 cursor-pointer text-[13px] font-bold text-navy-900 bg-lime-500 hover:bg-lime-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
            {resolvedLoadingLabel}
          </>
        ) : (
          submitLabel
        )}
      </button>
    </div>
  );
}
